import createNamedContext from "./createNamedContext";

const context = /*#__PURE__*/ createNamedContext("Router");
export default context;
